import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AppActions, AppActionTypes } from './actions';
import { PhosphateLegalNorm, PhosphateLegalNormState } from '../shared/models';

export const phosphateLegalNormAdapter: EntityAdapter<PhosphateLegalNorm> = createEntityAdapter<PhosphateLegalNorm>();
export const initialPhosphateLegalNormState: PhosphateLegalNormState = phosphateLegalNormAdapter.getInitialState({});

export function phosphateLegalNormReducer(state = initialPhosphateLegalNormState, action: AppActions): PhosphateLegalNormState {
  switch (action.type) {
    case AppActionTypes.LoadPhosphateLegalNormsSuccess: {
      const removedState = phosphateLegalNormAdapter.removeAll(state);
      return phosphateLegalNormAdapter.upsertMany(action.phosphateLegalNorms, removedState);
    }

    case AppActionTypes.UpsertPhosphateLegalNormSuccess: {
      return phosphateLegalNormAdapter.upsertOne(action.phosphateLegalNorm, state);
    }

    case AppActionTypes.DeletePhosphateLegalNormSuccess: {
      return phosphateLegalNormAdapter.removeOne(action.phosphateLegalNorm.id, state);
    }

    default: {
      return state;
    }
  }
}
